/**
 * The frame every « Vue d'ensemble » card sits in: uppercase caption title with an
 * optional colour dot, an optional header action or « voir plus » link, then the body.
 * Lifted out of `Dashboard.tsx` (2026-10-14) so cards living in their own file share it.
 */

import { Link as RouterLink } from 'react-router-dom';
import { Box, Card, CardContent, Typography } from '@mui/material';

export default function CardShell({
  title,
  dotColor,
  link,
  action,
  children,
}: {
  title: string;
  dotColor?: string;
  link?: { label: string; to: string };
  action?: React.ReactNode;
  children: React.ReactNode;
}) {
  return (
    <Card sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
      <CardContent sx={{ p: 2.5, flex: 1, '&:last-child': { pb: 2.5 } }}>
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 1, mb: 1.5 }}>
          <Typography
            variant="caption"
            sx={{
              color: 'text.secondary',
              fontWeight: 700,
              fontSize: '0.6875rem',
              textTransform: 'uppercase',
              letterSpacing: '0.05em',
              display: 'flex',
              alignItems: 'center',
              gap: 1,
            }}
          >
            {dotColor && <Box sx={{ width: 8, height: 8, borderRadius: '50%', bgcolor: dotColor }} />}
            {title}
          </Typography>
          {action}
          {link && (
            <Box
              component={RouterLink}
              to={link.to}
              sx={{ fontSize: 12.5, color: 'primary.main', textDecoration: 'none', fontWeight: 600, whiteSpace: 'nowrap', '&:hover': { textDecoration: 'underline' } }}
            >
              {link.label} →
            </Box>
          )}
        </Box>
        {children}
      </CardContent>
    </Card>
  );
}
